<div class="row">
    <div class="col-12" style="text-align: center;">
        <h1 class="text-center" style="color: green;">
            Agradecemos el envío de la receta <br/>médica o/y la respuesta.
        </h1>
        <br/>
        <p>Estamos evaluando cuidadosamente el contenido y nos pondremos en contacto a la <br/>brevedad posible con nuestra respuesta. Agradecemos su paciencia.</p>
    </div>
  </div>
  